var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublicIp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4a2 2 0 012-2h25a2 2 0 011.295.476l10 8.5A2 2 0 0144 12.5V44a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm4 2h20.5v7.5a2 2 0 002 2H40V42H9V6zm24.5 5.5h4.235L33.5 7.9v3.6zM15 18v16.5h4V18h-4zm7 2v-2h6.5a5.5 5.5 0 110 11H26v5.5h-4V20zm4 5h2.5a1.5 1.5 0 000-3H26v3z"
  })));
}

export default SvgPublicIp;